import styles from './SchemeInfo.module.css';

import arrowIcon from 'assets/svg/arrow-01.svg';

import SchemeEditor from '../../../../SchemeEditor';
import Card from 'ui/Card';
import RegularButton from 'ui/RegularButton';
import Icon from 'ui/Icon';
import { observer } from 'mobx-react-lite';
import { projectsStore } from 'store/mobx/projects.store';
import { useEffect, useState } from 'react';
import classNames from 'classnames';
import { schemesStore } from 'store/mobx/schemes.store';
import useAlert from 'hooks/useAlert';
import { useForm, FormProvider } from 'react-hook-form';
import FormSelect from 'ui/formItems/FormSelect';

const SchemeInfo = observer(() => {
  const [expandSchemePreview, setExpandSchemePreview] = useState(false);

  const { selectedProject, upsertProjectScheme } = projectsStore;
  const { schemes, setSchemes } = schemesStore;

  const { showAlert } = useAlert();
  const form = useForm({
    defaultValues: {
      id_scheme: selectedProject?.scheme?.id ?? '',
    },
  });

  const { handleSubmit, setValue, watch } = form;

  useEffect(() => {
    setValue('id_scheme', selectedProject?.scheme?.id ?? '');
  }, [selectedProject?.scheme?.id]);

  const selectedScheme = watch('id_scheme');

  useEffect(() => {
    if (selectedProject?.scheme?.id) {
      setValue('id_scheme', selectedProject.scheme.id);
    }
  }, [selectedProject]);

  const submitForm = async (data) => {
    const response = await upsertProjectScheme({
      ...data,
    });

    if (!response.success && response.error_code)
      return errorCommonAlert(response.error_code, response.error);

    if (response.success) {
      successUpsertAlert();
    }
  };

  const successUpsertAlert = () => {
    showAlert('Схема изменена успешно!', 'success');
  };

  const errorCommonAlert = (code, message) => {
    showAlert(`Код № ${code}${message ? ` - ${message}` : ''}.`, 'error');
  };

  return (
    <Card>
      <Card.Title text={'Производственная схема'}></Card.Title>
      <Card.Content className={styles.schemeInfo}>
        <FormProvider {...form}>
          <div className={styles.content}>
            <FormSelect
              name="id_scheme"
              className={styles.select}
              placeholder="Не выбрано"
              options={schemes}
              required={true}
              clearable={false}
              hideErrorBlock
            />
            <RegularButton
              variant={'flat'}
              text="Сохранить"
              onClick={handleSubmit(submitForm)}
              disabled={
                selectedProject?.scheme?.id?.toString() === selectedScheme.toString() ||
                !selectedScheme
              }
            />
          </div>
        </FormProvider>
        <RegularButton
          className={styles.expandButton}
          text={expandSchemePreview ? 'Свернуть' : 'Развернуть'}
          variant={'outlined'}
          color={'secondary'}
          onClick={() => setExpandSchemePreview(!expandSchemePreview)}
          appendIcon={
            <Icon
              className={classNames(styles.expandIcon, {
                [styles.expandedIcon]: expandSchemePreview,
              })}
              color={'var(--color-secondary)'}
              src={arrowIcon}
              width={'14px'}
              height={'14px'}
            />
          }
        />
        {expandSchemePreview && <SchemeEditor initialNodes={selectedProject.scheme?.nodes ?? []} />}
      </Card.Content>
    </Card>
  );
});

export default SchemeInfo;
